import PopperAction from "@/components/Shared/PopperAction";
import { Popper as MuiPopper } from "@mui/material";
import { createContext, useContext, useState } from "react";

interface ActionPopperContextValues {
  popper: Popper;
  setPopper: React.Dispatch<React.SetStateAction<Popper>>;
}

export interface Popper {
  anchorEl: HTMLElement | null;
  data: any;
  actions: {
    title: string;
    icon: JSX.Element | null;
    handler: (data: any) => void;
    disabled?: boolean;
  }[];
}

interface ActionPopperContextProviderProps {
  children: JSX.Element;
}

const ActionPopperContext = createContext<ActionPopperContextValues>({
  popper: {
    anchorEl: null,
    data: null,
    actions: [],
  },
  setPopper: () => {},
});

const ActionPopperContextProvider = ({
  children,
}: ActionPopperContextProviderProps) => {
  const [popper, setPopper] = useState<Popper>({
    data: null,
    actions: [],
    anchorEl: null,
  });

  const handleClosePopper = () => {
    setPopper((prev) => ({ ...prev, actions: [] }));
  };

  return (
    <ActionPopperContext.Provider value={{ popper, setPopper }}>
      {children}

      {popper?.anchorEl && popper?.actions?.length > 0 && (
        <MuiPopper
          anchorEl={popper?.anchorEl}
          open={Boolean(popper.anchorEl)}
          sx={{ zIndex: 100 }}
        >
          <PopperAction {...popper} handleClose={handleClosePopper} />
        </MuiPopper>
      )}
    </ActionPopperContext.Provider>
  );
};

export const useActionPopperContext = () => {
  return useContext(ActionPopperContext);
};

export default ActionPopperContextProvider;
